<template>
    <Layout>

        <section class="section">
            <div class="container">
                <div class="no-free-will">
                    <div class="row">
                        <div class="col-md-12">
                            <h2>Invitation Cancellation</h2>
                            <p>
                                This is to confirm that you have cancelled your registration to attend {{ conferenceTextData.name }} Conference
                                <br>
                                <br>
                                We regret that we will not have the opportunity to welcome you at the Conference this year and hope to see you at our future conferences.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    </Layout>
</template>

<script>
import Layout from '@/components/layouts/Layout.vue'
import { mapGetters } from 'vuex';

export default {
    name: 'Cancellation',
    components: {Layout},
    computed: {
        ...mapGetters(['conferenceTextData'])
    }
};
</script>
